import React from 'react';
import { Box, Typography, Divider, Paper} from '@mui/material';
// import { getLibrarySeatLayout } from 'services/property';
// import SeatLayoutWithAvailablityOptions from 'components/SeatLayoutWithFilters';
import SeatLayout from 'components/SeatLayout';

const SeatLayoutPage = () => {

  // const getLibrarySeats = () => {
  // }

  // useEffect(() => {
  //   getLibrarySeats();
  // }, []);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom sx={{mb: 1}}>
        Seat Layout
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <SeatLayout />
      </Box>
    </Paper>
  );
}
 
export default SeatLayoutPage;
